module.exports = __webpack_public_path__ + "img/bllc12.fa803203.png";